module.exports = __webpack_public_path__ + "static/parisnco-536aee54fede39fa8b83c430b57b39ff.png";